<template>
    <BDropdown
        variant="default"
        toggle-class="p-0 dropdown-toggle-unset"
        menu-class="dropdown-user font-size-16"
        :right="true"
        :no-caret="true">
        <template #button-content>
            <div class="d-flex align-items-center justify-content-center dropdown-toggle ml-1" :class="{'p-02': !isSuperAdmin, 'p-1': isSuperAdmin}" v-ripple>
                <div v-if="isSuperAdmin" class="badge bg-danger-400 position-static">
                    EC Support
                </div>
                <Chip v-else :border-color="darkMenu ? '#fff' : '#232323'" :chip-classes="['chip-size-30', 'chip-border-1']" :user-name="userName" :user-role="userRole"/>
            </div>
        </template>

        <div class="dropdown-info">
            <p v-if="isSuperAdmin && !isMainDomain">
                <a :href="mainUrl + '/admin/accounts'" class="btn btn-light btn-sm ellipsis-nowrap" v-ripple>
                    <i class="icon-arrow-left8 mr-2"></i>Admin dashboard
                </a>
            </p>

            <p v-if="isSuperAdmin" class="font-italic">Logged in as</p>
            <p class="my-account-name">{{ userName }}</p>
            <p class="my-account-email">{{ userEmail }}</p>

            <p v-if="userRole && !isMainDomain" class="my-account-role">
                Role: <span class="font-weight-bold">{{ userRole }}</span>
            </p>

            <!-- TODO: create a modal window Change the user on vue -->
            <p v-if="isSuperAdmin && !isMainDomain">
                <a href="#" @click.prevent="clickImpersonateAnyUserModal" class="d-block link" v-ripple>Change the user</a>
            </p>
        </div>

        <!-- TODO: create a modal window Edit profile on vue -->
        <BLink href="#"
               v-if="!isMainDomain && Object.keys(currentUserAccount).length"
               @click.prevent="clickOpenEditProfile"
               class="dropdown-item"
               v-ripple>
            <i class="mi-mode-edit mr-1"></i><span>Edit profile</span>
        </BLink>
        <BLink v-if="!isMainDomain && isCurrentAccountOwner" href="/settings" class="dropdown-item" v-ripple>
            <i class="mi-settings mr-1"></i><span>Account settings</span>
        </BLink>
        <BLink v-if="!isMainDomain && Object.keys(currentUserAccount).length" :href="feedbacksUrl" class="dropdown-item" v-ripple>
            <i class="mi-thumbs-up-down mr-1"></i><span>My feedback</span>
        </BLink>
        <BDropdownItemButton @click="logOut" v-ripple>
            <i class="mi-exit-to-app mr-1"></i>
            Log out
        </BDropdownItemButton>

    </BDropdown>
</template>

<script>

import {mapGetters, mapState} from "vuex";
import {BDropdown, BDropdownItemButton, BLink} from "bootstrap-vue";
import Chip from "@/components/general/Chip";
import EventBus, {MAIN_WINDOW_CLICK} from "@/utils/event-bus";
import mixinNavbar from "@/mixins/navbar/mixin";

export default {
    name: 'DropdownUser',
    components: {
        BDropdownItemButton,
        Chip,
        BDropdown,
        BLink

    },
    computed: {
        ...mapGetters(['currentUserCan', 'isCurrentAccountOwner']),
        ...mapState({
            projectId: state => state.navbar.projectId,
            isSuperAdmin: state => state.navbar.isSuperAdmin,
            userId: state => state.navbar.user.id,
            userName: state => state.navbar.user.name,
            userEmail: state => state.navbar.user.email,
            userRole: state => state.navbar.user.role.name,
            darkMenu: state => state.navbar.darkMenu,
            showDemo: state => state.navbar.showDemo,
            isMainDomain: state => state.navbar.isMainDomain,
            currentUserAccount: state => state.navbar.currentUserAccount,
        }),
        feedbacksUrl: vm => `/user/${vm.userId}/feedbacks`,
    },
    methods: {
        onWindowClick(event) {
            if (
                this.$refs?.messagesWidget
                && this.$refs.messagesWidget !== event.target
                && !this.$refs.messagesWidget.contains(event.target)
            ) {
                this.showMessagesWidget = false;
            }
        },
        logOut() {
            let form = document.createElement('form');
            let csrfInput = document.createElement('input');
            const metaCsrfToken = document.querySelector('meta[name="csrf-token"]');
            const csrfToken = metaCsrfToken.getAttribute('content');

            form.setAttribute('method', 'post');
            form.setAttribute('action', '/logout');

            csrfInput.setAttribute('type', 'hidden');
            csrfInput.setAttribute('name', '_csrf');
            csrfInput.setAttribute('value', csrfToken);

            form.appendChild(csrfInput);
            document.body.appendChild(form);
            form.submit();
        },
        clickOpenEditProfile() {
            const eventName = this.currentUserCan('manage_users') ? 'open-edit-my-profile-modal' : 'open-edit-user-without-permission-modal';
            document.dispatchEvent(new Event(eventName));
        },
        clickImpersonateAnyUserModal() {
            if (!this.isSuperAdmin) {
                return;
            }
            document.dispatchEvent(new Event('open-super-admin-impersonate-any-user-modal'));
        }
    },
    mounted() {
        EventBus.on(MAIN_WINDOW_CLICK, this.onWindowClick);
    },
    destroyed() {
        EventBus.off(MAIN_WINDOW_CLICK, this.onWindowClick);
    },
    mixins: [mixinNavbar],
    data() {
        return {
            showMessagesWidget: false
        }
    }
}
</script>
